import { useState } from 'react';
import { sb, saveConfig } from '../../lib/supabase.js';
import schemaSql from '../../../supabase/schema.sql?raw';
import { toast } from '../../store/ui.js';

export function LoginScreen({ onLogin }) {
  const [email, setEmail] = useState(localStorage.getItem('sb_email') || '');
  const [pass, setPass] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  async function forgot() {
    if (!email.trim()) return setErr('כתוב קודם את האימייל, ואז לחץ שוב');
    setErr('');
    const { error } = await sb().auth.resetPasswordForEmail(email.trim(), { redirectTo: location.origin });
    if (error) return setErr(error.message);
    setSent(true);
  }
  async function go(e) {
    e.preventDefault();
    if (!email || !pass) return setErr('נא למלא אימייל וסיסמה');
    setErr('');
    setBusy(true);
    const { error } = await sb().auth.signInWithPassword({ email: email.trim(), password: pass });
    setBusy(false);
    if (error) { setErr(error.message === 'Invalid login credentials' ? 'אימייל או סיסמה שגויים' : error.message); setPass(''); return; }
    localStorage.setItem('sb_email', email.trim());
    onLogin();
  }
  return (
    <div className="fullscreen">
      <form className="box" style={{ textAlign: 'center', maxWidth: 340 }} onSubmit={go}>
        <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>🔐</div>
        <h2>תקציב משפחתי</h2>
        <p className="box-sub">התחברות לחשבון</p>
        <input type="email" placeholder="אימייל" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} style={{ textAlign: 'center', marginBottom: 8 }} />
        <input type="password" placeholder="סיסמה" autoComplete="current-password" value={pass} onChange={(e) => setPass(e.target.value)} style={{ textAlign: 'center', marginBottom: 10 }} />
        {err && <div style={{ color: 'var(--red)', fontSize: '.9rem', marginBottom: 10 }}>{err}</div>}
        <button className="ubtn ubtn-primary w100" disabled={busy} type="submit">{busy ? <span className="sp" /> : 'כניסה'}</button>
        {sent ? <div className="note mt12 green">נשלח מייל עם קישור לבחירת סיסמה חדשה</div>
          : <button type="button" className="link-muted mt12" onClick={forgot}>שכחתי סיסמה</button>}
      </form>
    </div>
  );
}

export function SetupScreen({ onDone }) {
  const [tab, setTab] = useState(0);
  const [url, setUrl] = useState('');
  const [key, setKey] = useState('');
  const [err, setErr] = useState('');
  function connect() {
    const u = url.trim().replace(/\/$/, ''), k = key.trim();
    if (!u || !k) return setErr('נא למלא שדות');
    if (!/^https:\/\/.+\.supabase\.co$/.test(u)) return setErr('URL לא תקין');
    saveConfig(u, k);
    onDone();
  }
  return (
    <div className="fullscreen">
      <div className="box">
        <h2>🏠 תקציב משפחתי</h2>
        <p className="box-sub">חבר לפרויקט Supabase חינמי</p>
        <div className="stabs">
          <button className={'stab' + (tab === 0 ? ' on' : '')} onClick={() => setTab(0)}>1. הגדרת DB</button>
          <button className={'stab' + (tab === 1 ? ' on' : '')} onClick={() => setTab(1)}>2. התחברות</button>
        </div>
        {tab === 0 ? (
          <>
            <p style={{ fontSize: '.86rem', color: 'var(--ink2)', marginBottom: 9 }}>הרץ ב-<b>SQL Editor</b>:</p>
            <div className="sql" dir="ltr">{schemaSql}</div>
            <button className="copy-btn" onClick={() => navigator.clipboard && navigator.clipboard.writeText(schemaSql).then(() => toast('✅ הועתק'))}>📋 העתק SQL</button>
            <button className="ubtn ubtn-primary w100" onClick={() => setTab(1)}>המשך ←</button>
          </>
        ) : (
          <>
            <div className="field"><label>Supabase Project URL</label><input type="url" dir="ltr" placeholder="https://xxxx.supabase.co" value={url} onChange={(e) => setUrl(e.target.value)} /></div>
            <div className="field"><label>Supabase Anon Key</label><input dir="ltr" placeholder="eyJ..." value={key} onChange={(e) => setKey(e.target.value)} /></div>
            <button className="ubtn ubtn-primary w100" onClick={connect}>התחבר</button>
            {err && <div className="err-box" style={{ display: 'block' }}>{err}</div>}
            <div className="note mt12">אפשר גם להגדיר VITE_SUPABASE_URL ו-VITE_SUPABASE_ANON_KEY בקובץ .env.local, ואז המסך הזה לא יופיע.</div>
          </>
        )}
      </div>
    </div>
  );
}

/** אחרי לחיצה על הקישור במייל "שכחתי סיסמה" */
export function NewPasswordScreen({ onDone }) {
  const [pass, setPass] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  async function go(e) {
    e.preventDefault();
    if (pass.length < 6) return setErr('לפחות 6 תווים');
    setBusy(true);
    const { error } = await sb().auth.updateUser({ password: pass });
    setBusy(false);
    if (error) return setErr(error.message);
    history.replaceState(null, '', location.pathname);
    toast('✅ הסיסמה עודכנה');
    onDone();
  }
  return (
    <div className="fullscreen">
      <form className="box" style={{ textAlign: 'center', maxWidth: 340 }} onSubmit={go}>
        <h2>סיסמה חדשה</h2>
        <p className="box-sub">בחר סיסמה חדשה לחשבון</p>
        <input type="password" autoComplete="new-password" placeholder="סיסמה חדשה" value={pass} onChange={(e) => setPass(e.target.value)} style={{ textAlign: 'center', marginBottom: 10 }} />
        {err && <div style={{ color: 'var(--red)', fontSize: '.9rem', marginBottom: 10 }}>{err}</div>}
        <button className="ubtn ubtn-primary w100" disabled={busy} type="submit">{busy ? <span className="sp" /> : 'שמור סיסמה'}</button>
      </form>
    </div>
  );
}
